import React, { createContext, useState } from "react";

/**
 * デフォルト値を設定
 * - isSidebarShow
 */
export const GuidePageSidebarContext = createContext({ isSidebarShow: true });


export const GuidePageSidebarProvider = ({ children }) => {

	const [isSidebarShow, setIsSidebarShow] = useState(true);

	return (
		<GuidePageSidebarContext.Provider value={{ isSidebarShow, setIsSidebarShow }}>
			{children}
		</GuidePageSidebarContext.Provider>
	);
};
